import React from 'react';
import {MiitelSetting, useCreateMiitelCallPreleadActivityMutation} from 'api';
import {miitelCall, mountMiitelWidget} from 'helpers/miitelWidget';

const useMiitel = (preleadUuid: string, miitelSetting: MiitelSetting) => {
  const [createMiitelCallPreleadActivity] =
    useCreateMiitelCallPreleadActivityMutation();

  React.useEffect(() => {
    if (!miitelSetting?.isAvailable || !miitelSetting?.isActive || !preleadUuid)
      return;

    return mountMiitelWidget(miitelSetting, (miitelSequenceId) =>
      createMiitelCallPreleadActivity({
        variables: {preleadUuid, miitelSequenceId},
      }),
    );
  }, [miitelSetting, preleadUuid]);
};

export {useMiitel, miitelCall};
